module.exports = __webpack_public_path__ + "img/478898-18-9.b1cfe241.png";